// 메인 패키지 엔트리 — App을 #root에 렌더링
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import { initLocale } from './lib/locale';
// 공용 컴포넌트 스타일 (webpack4는 exports 맵을 못 읽으므로 dist 경로 직접 지정)
import 'yukimushi-component-fe/dist/style.css';
import './index.css';

// 첫 렌더 전에 표시 언어를 정한다 — ?lang=ja 같은 로딩 파라미터가 저장값보다 우선한다
initLocale();

ReactDOM.render(<App />, document.getElementById('root'));
